import { Box, Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import AadhaarCardStateCard from './AadhaarCardStateCard';
import DLStateCard from './DLStateCard';
import PanStateCard from './PanStateCard';
import BackgroundVerification from '../../../../src/components/Containers/BGVStatus';
import { KycRevealProvider } from '../../../components/KYC/reveal';

interface HireVerifyKYCProps {
    leadInfo?: any;
    toggleLoading?: any;
    dispatchFetchBasicLeadkyc?: Function;
    onValueChange?: Function;
    onInoChange?: Function;
}

const HireVerifyKYC: React.FC<HireVerifyKYCProps> = ({
    leadInfo,
    toggleLoading,
    dispatchFetchBasicLeadkyc,
    onValueChange,
    onInoChange,
}) => {
    const [kycInfo, setKYCInfo] = useState<any>(null);
    const [kycState, setKycState] = useState({
        aadhar: {},
        panCard: {},
        drivingLicense: {},
        panSkipped: false,
    });

    const fetchLeadKycDetails = () => {
        toggleLoading(true);
        if (dispatchFetchBasicLeadkyc) {
            dispatchFetchBasicLeadkyc(
                leadInfo?.id,
                {},
                (resp: any) => {
                    let values = {
                        ...resp?.response,
                        dob: !!resp?.response?.dob ? resp?.response?.dob : null,
                    };
                    setKYCInfo(values);
                    onInoChange?.(values);
                    toggleLoading(false);
                },
                (err: any) => {
                    toggleLoading(false);
                },
            );
        }
    };
    useEffect(() => {
        fetchLeadKycDetails?.();
    }, []);

    useEffect(() => {
        onValueChange?.(kycState);
    }, [kycState, onValueChange]);

    useEffect(() => {
        const leadInfoDob = kycInfo?.dob;

        const eq = (a: any, b: any) =>
            a != null && b != null ? String(a) === String(b) : false;

        const makePayload = (src: any) => ({
            ...(src ?? {}),
            dob: leadInfoDob,
            manualVerificationRequired:
                src?.manualVerificationRequired ||
                (!!src?.autoKycDocumentDob &&
                    !!leadInfoDob &&
                    !eq(src?.autoKycDocumentDob, leadInfoDob)),
            isDobMatching: src?.autoKycDocumentNo
                ? true
                : !!src?.autoKycDocumentDob && !!leadInfoDob
                  ? eq(src?.autoKycDocumentDob, leadInfoDob)
                  : true,
            // Server-computed on the raw values. Do NOT compare documentNo to
            // autoKycDocumentNo here: both are masked, and two different numbers sharing a
            // last-4 mask identically, so a genuine mismatch would read as a match.
            isDocumentNumberMatching:
                src?.docNumberMismatch == null
                    ? !(
                          !!src?.autoKycDocumentNo &&
                          !!src?.documentNo &&
                          !eq(src?.autoKycDocumentNo, src?.documentNo)
                      )
                    : !src?.docNumberMismatch,
        });

        const newState = {
            aadhar: makePayload(kycInfo?.aadhar),
            panCard: makePayload(kycInfo?.panCard),
            //rc: makePayload(kycInfo?.rc),
            drivingLicense: makePayload(kycInfo?.drivingLicense),
            panSkipped: !!kycInfo?.panSkipped,
        };
        setKycState(newState);
    }, [kycInfo]);

    const bgvStatusList = kycInfo?.bgvStatus ?? [];
    const showBGVStatus = bgvStatusList.length > 0;

    return !!kycInfo ? (
        <KycRevealProvider
            entityType="LEAD"
            entityId={leadInfo?.id}
            onRevealed={fetchLeadKycDetails}
        >
            <Box style={{ padding: '20px 0 0 0' }}>
                <Grid container spacing={0} style={{ marginBottom: '12px' }}>
                    <AadhaarCardStateCard
                        payload={kycState?.aadhar}
                        setPayload={(payload: any) => {
                            setKycState((prev) => ({
                                ...prev,
                                aadhar: {
                                    ...prev?.aadhar,
                                    ...payload,
                                },
                            }));
                        }}
                    />
                    <PanStateCard
                        payload={kycState?.panCard}
                        panSkipped={kycState?.panSkipped}
                        setPayload={(payload: any) => {
                            setKycState((prev) => ({
                                ...prev,
                                panCard: {
                                    ...prev?.panCard,
                                    ...payload,
                                },
                            }));
                        }}
                    />
                    <DLStateCard
                        payload={kycState?.drivingLicense}
                        setPayload={(payload: any) => {
                            setKycState((prev) => ({
                                ...prev,
                                drivingLicense: {
                                    ...prev?.drivingLicense,
                                    ...payload,
                                },
                            }));
                        }}
                    />
                </Grid>
                {showBGVStatus && (
                    <Grid item xs={12}>
                        <BackgroundVerification bgvStatusList={bgvStatusList} />
                    </Grid>
                )}
            </Box>
        </KycRevealProvider>
    ) : null;
};

export default HireVerifyKYC;
